import React from 'react';
import { connect } from 'react-redux';
import { Form, Grid } from 'semantic-ui-react';
import { reduxForm, getFormValues } from 'redux-form';
import { withRouter } from 'react-router';
import { ZERO_NEGATIVE_BALANCE_FORM_NAME } from 'Common/FormEnum';
import CheckboxListComponent from 'Common/CheckboxListComponent';

function ZeroNegativeBalanceFormContainer(props) {
  return (
    <Form>
      <Grid>
        <Grid.Row>
          <Grid.Column className="field">
            <div>
              <label className={'p-b-0'}>Meal Status:</label>
            </div>
            <Grid
              className={'segment'}
              style={{
                background: '#F9F9F9',
                paddingTop: '5px',
                minWidth: '740px',
              }}
            >
              <Grid.Row>
                <CheckboxListComponent
                  {...props}
                  title={''}
                  showAll={true}
                  displayItems={props.statusCheckboxes}
                />
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
}

const mapStateToProps = state => {
  return {
    formValues: getFormValues(ZERO_NEGATIVE_BALANCE_FORM_NAME)(state),
  };
};

export const ZeroNegativeBalanceForm = reduxForm({
  form: ZERO_NEGATIVE_BALANCE_FORM_NAME,
  enableReinitialize: true,
})(withRouter(connect(mapStateToProps)(ZeroNegativeBalanceFormContainer)));



// WEBPACK FOOTER //
// ./src/pages/utilities/zeroNegativeBalance/components/ZeroNegativeBalanceForm.js